import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { ConnectChartMogulInput } from './useConnectChartMogulManager';

export default function useConnectChartMogulUser() {
  const queryClient = useQueryClient();

  const connectChartMogul = (input: Pick<ConnectChartMogulInput, 'email'>) => {
    const request: Request = {
      url: `${ENDPOINTS.chartMogul.connect.user}`,
      config: {
        method: 'post',
        data: input,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    Pick<ConnectChartMogulInput, 'email'>
  >(connectChartMogul, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.toString().startsWith(ENDPOINTS.chartMogul.main),
      });
    },
  });

  return { data, mutate, ...rest };
}
